import { mergeDeep } from '@sitecore-search/common';
import WidgetsConfig from './widgetsConfig.js';
const map = (propsStateMapping, request, props) => {
    Object.keys(props).forEach((prop) => {
        if (typeof propsStateMapping[prop] === 'function') {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore it's already validated that the prop is defined
            propsStateMapping[prop](request, props);
        }
    });
};
export const mapById = (rfkId, request, props = {}) => {
    const { options: { propStateMapping = null, props: { initial = {} } = {} } = {} } = WidgetsConfig.get(rfkId) || {};
    if (propStateMapping) {
        map(propStateMapping, request, mergeDeep(initial, props));
    }
};
